import React, { useRef } from 'react';
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import HowItWorks from './components/HowItWorks';
import CostExample from './components/CostExample';
import WhoItsFor from './components/WhoItsFor';
import ProjectFit from './components/ProjectFit';
import WhyBizsoft from './components/WhyBizsoft';
import Testimonials from './components/Testimonials';
import ROICalculator from './components/ROICalculator';
import Comparison from './components/Comparison';
import FAQ from './components/FAQ';
import ContactForm from './components/ContactForm';
import Footer from './components/Footer';
import ChatWidget from './components/ChatWidget';
import './App.css';

function App() {
  const contactFormRef = useRef(null);

  const scrollToContactForm = () => {
    if (contactFormRef.current) {
      const offset = 80;
      const elementPosition = contactFormRef.current.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <div className="App">
      <Navigation onCTAClick={scrollToContactForm} />
      <Hero onCTAClick={scrollToContactForm} />
      <HowItWorks />
      <CostExample />
      <WhoItsFor />
      <ProjectFit />
      <WhyBizsoft />
      <Testimonials />
      <ROICalculator />
      <Comparison />
      <FAQ />
      <ContactForm formRef={contactFormRef} />
      <Footer />
      <ChatWidget />
    </div>
  );
}

export default App;
